import { enablePointerEvents } from '@utils/pointer-events-control';
import { gameState, config } from '@js/state';

let val = 5;
let level = 1;
let pressed = false;
let wrongAttempt = 0;
let next = 0;
let levelSkippedNo = 0;
let bulb = 0;
let clickedY = 0;
let currentY = 103 + 5 * 56;
let retry = false;
let cam;
let lights = [];
let wrongClicked = false;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    cam = this.cameras.main;
    this.boy = this.add
      .image(30, 720, 'boy')
      .setOrigin(0, 1)
      .setScale(1, 1.02)
      .setDepth(10);
    gameState.lastButton = 103 + 5 * 56;
    gameState.floorNo = 0;
    gameState.wrong = 0;
    gameState.hintState = false;
    gameState.hintClicked = false;
    gameState.buttonState = '';
    gameState.hintUsed = 0;
    gameState.prevHint = 0;
    val = 5;
    level = 1;
    pressed = false;
    wrongAttempt = 0;
    wrongClicked = false;
    next = 0;
    levelSkippedNo = 0;
    bulb = 0;
    ((clickedY = 0), (currentY = 103 + 5 * 56));
    lights = [];

    cam = this.cameras.main;
    this.bgAudio = this.sound.add('bgMusic').setVolume(0.02).setLoop(true);
    this.vol = this.add.sprite(0, 0);
    this.emovingAudio = this.sound.add('emoving').setLoop(true);

    this.erfloorAudio = this.sound.add('erfloor').setVolume(0.05);

    this.edopenAudio = this.sound.add('edopen').setVolume(0.05);
    this.ebpressAudio = this.sound.add('ebpress').setVolume(0.05);
    this.incorrectAudio = this.sound.add('incorrectAudio').setVolume(0.05);
    this.logoAudio = this.sound.add('logoAudio').setVolume(0.05);

    this.confettiWelcome = this.sound.add('confettiWelcome').setVolume(0.05);

    this.bgAudio.play();
    this.emovingAudio.play();
    this.stopvid = false;
    this.cameras.main.setBounds(0, 0, 1280, 720);

    this.anims.create({
      key: 'epop',
      frames: this.anims.generateFrameNames('checkConfettiAnim', {
        start: 0,
        end: 47,
        prefix: 'checkconfetti',
        suffix: '.png',
      }),
      frameRate: 25,
      repeat: 0,
    });

    this.bg = this.add.image(0, 0, 'Q1').setOrigin(0);

    this.shadow = this.add.image(561.5, 664.8, 'shadow1').setOrigin(0);

    //this.hello = this.add.sprite(150,50,'walkAnim').setOrigin(0).setAlpha(0);
    this.helloQ1 = this.add.sprite(-10, -25, 'CharacterQ1Anim').setOrigin(0);

    //this.hello.play('hello')
    this.anims.create({
      key: 'helloI' + level,
      frames: this.anims.generateFrameNames('CharacterQ' + level + 'Anim', {
        start: 0,
        end: 0,
        prefix: 'CharacterQ' + level + '_',
        //prefix:()=>{if(level==1){return "CharacterQ1_"}} ,
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'helloQ' + level,
      frames: this.anims.generateFrameNames('CharacterQ' + level + 'Anim', {
        start: 0,
        end: 22,
        prefix: 'CharacterQ' + level + '_',
        //prefix:()=>{if(level==1){return "CharacterQ1_"}} ,
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'helloQ' + level + '2',
      frames: this.anims.generateFrameNames('CharacterQ' + level + 'Anim', {
        start: 23,
        end: 68,
        prefix: 'CharacterQ' + level + '_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 4,
    });

    this.confetti = this.add.sprite(440, 300, 'checkConfettiAnim').setScale(1.6);

    this.wish = this.add.image(431, 328, 'QW1').setOrigin(0.5, 0).setAlpha(0);
    this.ldoor = this.add.image(432, 0, 'ldoor').setOrigin(1, 0);
    this.rdoor = this.add.image(430, 0, 'rdoor').setOrigin(0, 0);
    this.lift = this.add.image(0, 0, 'lift').setOrigin(0);

    this.number = this.add
      .text(430, 27, '0', { fontFamily: 'font1', fontSize: '40px', fill: '#FFCF56' })
      .setOrigin(0.5, 0);

    this.panelBoard = this.add.image(945, 20, 'panelBoard').setOrigin(0);

    this.upArrow = this.add.image(309, 33, 'upArrow').setOrigin(0);
    this.downArrow = this.add.image(515, 33, 'downArrow').setOrigin(0);

    this.upArrow_w = this.add.image(309, 33, 'upArrow_w').setOrigin(0).setAlpha(-10);
    this.downArrow_w = this.add.image(515, 33, 'downArrow_w').setOrigin(0).setAlpha(-10);

    this.beed = this.physics.add.sprite(992, 362.5, 'beed').setOrigin(0, -0.1); //+ 5*56
    gameState.beedY = 362.5;

    this.statement = this.add.image(431, 169, 'QS1').setAlpha(0).setOrigin(0.5, 0);

    this.tweens.add({
      targets: this.statement,
      alpha: 1,
      ease: 'sine.easeOut',
      duration: 400,
      delay: 10000 + 300,
      repeat: 0,
    });

    //bulbs
    this.green1 = this.add.image(956.5, 20, 'green').setOrigin(0).setVisible(false);
    this.green2 = this.add
      .image(956.5 + 39, 20, 'green')
      .setOrigin(0)
      .setVisible(false);
    this.green3 = this.add
      .image(956.5 + 2 * 39, 20, 'green')
      .setOrigin(0)
      .setVisible(false);
    this.green4 = this.add
      .image(957 + 3 * 39, 20, 'green')
      .setOrigin(0)
      .setVisible(false);
    this.green5 = this.add
      .image(957.5 + 4 * 39, 20, 'green')
      .setOrigin(0)
      .setVisible(false);
    this.green6 = this.add
      .image(958 + 5 * 39, 20, 'green')
      .setOrigin(0)
      .setVisible(false);

    lights.push(this.green1);
    lights.push(this.green2);
    lights.push(this.green3);
    lights.push(this.green4);
    lights.push(this.green5);
    lights.push(this.green6);

    this.buttons();

    this.Floor0.setTexture('0_d').disableInteractive();
  } //create close

  buttons() {
    this.Floor5 = this.add.image(1101, 103, '5_on').setInteractive({ cursor: 'pointer' });
    this.Floor4 = this.add
      .image(1101, 103 + 56, '4_on')
      .setInteractive({ cursor: 'pointer' });
    this.Floor3 = this.add
      .image(1101, 103 + 2 * 56, '3_on')
      .setInteractive({ cursor: 'pointer' });
    this.Floor2 = this.add
      .image(1101, 103 + 3 * 56, '2_on')
      .setInteractive({ cursor: 'pointer' });
    this.Floor1 = this.add
      .image(1101, 103 + 4 * 56, '1_on')
      .setInteractive({ cursor: 'pointer' });
    this.Floor0 = this.add
      .image(1101, 103 + 5 * 56, '0_on')
      .setInteractive({ cursor: 'pointer' });
    this.FloorMinus1 = this.add
      .image(1101, 103 + 6 * 56, '-1_on')
      .setInteractive({ cursor: 'pointer' });
    this.FloorMinus2 = this.add
      .image(1101, 103 + 7 * 56, '-2_on')
      .setInteractive({ cursor: 'pointer' });
    this.FloorMinus3 = this.add
      .image(1101, 103 + 8 * 56, '-3_on')
      .setInteractive({ cursor: 'pointer' });
    this.FloorMinus4 = this.add
      .image(1101, 103 + 9 * 56, '-4_on')
      .setInteractive({ cursor: 'pointer' });
    this.FloorMinus5 = this.add
      .image(1101, 103 + 10 * 56, '-5_on')
      .setInteractive({ cursor: 'pointer' });
    gameState.lastButtonName = '0_d';
    this.floors = [
      this.Floor5,
      this.Floor4,
      this.Floor3,
      this.Floor2,
      this.Floor1,
      this.Floor0,
      this.FloorMinus1,
      this.FloorMinus2,
      this.FloorMinus3,
      this.FloorMinus4,
      this.FloorMinus5,
    ];

    this.questionFloors = [
      this.Floor0,
      this.FloorMinus4,
      this.Floor5,
      this.Floor3,
      this.Floor2,
      this.FloorMinus5,
      this.Floor1,
      this.Floor4,
      this.FloorMinus3,
      this.FloorMinus2,
      this.FloorMinus1,
    ];

    this.floorNo = ['0', '-4', '5', '3', '2', '-5', '1', '4', '-3', '-2', '-1'];

    this.press1 = true;

    this.Floor5.on(
      'pointerover',
      function () {
        this.Floor5.setTexture('5_h');
      },
      this,
    );

    this.Floor5.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor5.setTexture('5_on');
        } else {
          this.Floor5.setTexture('5_');
        }
      },
      this,
    );

    this.Floor5.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor5.y;
        this.Floor5.setTexture('5_');
        val = 5;
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // console.log("blank"+ gameState.buttonState);
      },
      this,
    );

    this.Floor4.on(
      'pointerover',
      function () {
        this.Floor4.setTexture('4_h');
      },
      this,
    );

    this.Floor4.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor4.setTexture('4_on');
        } else {
          this.Floor4.setTexture('4_');
        }
      },
      this,
    );

    this.Floor4.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor4.y;
        val = 4;
        this.Floor4.setTexture('4_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // gameState.hintButtonClose=true;
      },
      this,
    );

    this.Floor3.on(
      'pointerover',
      function () {
        this.Floor3.setTexture('3_h');
      },
      this,
    );

    this.Floor3.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor3.setTexture('3_on');
        } else {
          this.Floor3.setTexture('3_');
        }
      },
      this,
    );

    this.Floor3.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor3.y;
        val = 3;
        this.Floor3.setTexture('3_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        //  gameState.hintButtonClose=true;
      },
      this,
    );

    this.Floor2.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor2.y;
        val = 2;
        this.Floor2.setTexture('2_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // gameState.hintButtonClose=true;
      },
      this,
    );

    this.Floor2.on(
      'pointerover',
      function () {
        this.Floor2.setTexture('2_h');
      },
      this,
    );

    this.Floor2.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor2.setTexture('2_on');
        } else {
          this.Floor2.setTexture('2_');
        }
      },
      this,
    );

    this.Floor1.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor1.y;
        val = 1;
        this.Floor1.setTexture('1_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // gameState.hintButtonClose=true;
      },
      this,
    );

    this.Floor1.on(
      'pointerover',
      function () {
        this.Floor1.setTexture('1_h');
      },
      this,
    );

    this.Floor1.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor1.setTexture('1_on');
        } else {
          this.Floor1.setTexture('1_');
        }
      },
      this,
    );

    this.Floor0.on(
      'pointerover',
      function () {
        this.Floor0.setTexture('0_h');
      },
      this,
    );

    this.Floor0.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.Floor0.setTexture('0_on');
        } else {
          this.Floor0.setTexture('0_');
        }
      },
      this,
    );

    this.Floor0.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.Floor0.y;
        val = 0;
        this.Floor0.setTexture('0_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // gameState.hintButtonClose=true;
      },
      this,
    );

    this.FloorMinus1.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.FloorMinus1.y;
        val = -1;
        this.FloorMinus1.setTexture('-1_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
        // gameState.hintButtonClose=true;
      },
      this,
    );

    this.FloorMinus1.on(
      'pointerover',
      function () {
        this.FloorMinus1.setTexture('-1_h');
      },
      this,
    );

    this.FloorMinus1.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.FloorMinus1.setTexture('-1_on');
        } else {
          this.FloorMinus1.setTexture('-1_');
        }
      },
      this,
    );

    this.FloorMinus2.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.FloorMinus2.y;
        val = -2;
        this.FloorMinus2.setTexture('-2_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
      },
      this,
    );

    this.FloorMinus2.on(
      'pointerover',
      function () {
        this.FloorMinus2.setTexture('-2_h');
      },
      this,
    );

    this.FloorMinus2.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.FloorMinus2.setTexture('-2_on');
        } else {
          this.FloorMinus2.setTexture('-2_');
        }
      },
      this,
    );
    this.FloorMinus3.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.FloorMinus3.y;
        val = -3;
        this.FloorMinus3.setTexture('-3_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
      },
      this,
    );

    this.FloorMinus3.on(
      'pointerover',
      function () {
        this.FloorMinus3.setTexture('-3_h');
      },
      this,
    );

    this.FloorMinus3.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.FloorMinus3.setTexture('-3_on');
        } else {
          this.FloorMinus3.setTexture('-3_');
        }
      },
      this,
    );

    this.FloorMinus4.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.FloorMinus4.y;
        val = -4;
        this.FloorMinus4.setTexture('-4_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
      },
      this,
    );

    this.FloorMinus4.on(
      'pointerover',
      function () {
        this.FloorMinus4.setTexture('-4_h');
      },
      this,
    );

    this.FloorMinus4.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.FloorMinus4.setTexture('-4_on');
        } else {
          this.FloorMinus4.setTexture('-4_');
        }
      },
      this,
    );

    this.FloorMinus5.on(
      'pointerdown',
      () => {
        pressed = true;
        clickedY = this.FloorMinus5.y;
        val = -5;
        this.FloorMinus5.setTexture('-5_');
        if (gameState.hintState == false) {
          gameState.buttonState = '_';
        }
      },
      this,
    );

    this.FloorMinus5.on(
      'pointerover',
      function () {
        this.FloorMinus5.setTexture('-5_h');
      },
      this,
    );

    this.FloorMinus5.on(
      'pointerout',
      function () {
        if (this.press1) {
          this.FloorMinus5.setTexture('-5_on');
        } else {
          this.FloorMinus5.setTexture('-5_');
        }
      },
      this,
    );
  }

  blurFunction() {
    this.time.delayedCall(
      800,
      () => {
        gameState.gameWin = true;
        //this.scene.pause("GameScene");
        this.kawase = this.plugins.get('rexkawaseblurpipelineplugin');
        this.kawase.add(cam, config);

        this.endOverlay = this.add
          .sprite(config.width / 2, config.height / 2, 'overlay')
          .setDepth(10);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.lift, config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.panelBoard, config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.ldoor, config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.rdoor, config);
        // // this.plugins.get('rexkawaseblurpipelineplugin').add(this.greyButton,config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.questionFloors[next], config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.beed, config);
        // for (let i = 0; i < lights.length; i++) this.plugins.get("rexkawaseblurpipelineplugin").add(lights[i], config);
        // this.plugins.get("rexkawaseblurpipelineplugin").add(this.number, config);
        // for (let i = 0; i < this.floors.length; i++) this.plugins.get("rexkawaseblurpipelineplugin").add(this.floors[i], config);
      },
      this,
      [],
    );
  }

  update() {
    this.cameras.main.centerOn(430, 360);
    this.bg.setTexture('Q' + level);
    this.statement.setTexture('QS' + level);
    if (
      (gameState.attempted >= 10 && gameState.score < 6) ||
      (gameState.score >= 6 && gameState.attempted <= 10)
    )
      this.statement.setAlpha(0);
    this.wish.setTexture('QW' + level);

    this.emovingAudio.setVolume(this.vol.x);

    if (
      pressed == true &&
      ((level == 1 && val == -4) ||
        (level == 2 && val == 5) ||
        (level == 3 && val == 3) ||
        (level == 4 && val == 2) ||
        (level == 5 && val == -5) ||
        (level == 6 && val == 1) ||
        (level == 7 && val == 4) ||
        (level == 8 && val == -3) ||
        (level == 9 && val == -2) ||
        (level == 10 && val == -1))
    ) {
      if (level <= 10) {
        if (level == 1) this.helloQ1.play('helloI1');
        if (level == 2 || level == 7) this.helloQ1.play('helloI2');
        if (level == 3 || level == 8) this.helloQ1.play('helloI3');
        if (level == 4 || level == 10) this.helloQ1.play('helloI4');
        if (level == 5 || level == 6 || level == 9) this.helloQ1.play('helloI5');
      }
      this.ebpressAudio.play();
      this.press1 = false;
      wrongAttempt = 0;
      gameState.wrong = 0;
      pressed = false;

      this.statement.setAlpha(0);
      for (let i = 0; i <= 10; i++) {
        this.floors[i].disableInteractive();
      }
      //console.log("LevelOn"+level)
      if (clickedY > currentY) this.downArrow.setTexture('downArrow_on');
      if (clickedY < currentY) this.upArrow.setTexture('upArrow_on');

      if (level == 1) this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      else if (level == 2 || level == 7) {
        this.wish.y = 230;
        if (level == 2) {
          this.shadow.setTexture('shadow2');
        }
        if (level == 7) {
          this.shadow.setTexture('shadow7');
        }
        this.shadow.x = 574.25;
        this.shadow.y = 659.33;

        this.helloQ1.x = 15;
        this.helloQ1.y = 25;
        this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      } else if (level == 3 || level == 8) {
        this.wish.y = 269;
        if (level == 3) {
          this.shadow.setTexture('shadow3');
        }
        if (level == 8) {
          this.shadow.setTexture('shadow8');
        }
        this.shadow.x = 571.66;
        this.shadow.y = 649.89;

        this.helloQ1.x = 25;
        this.helloQ1.y = 0;

        this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      } else if (level == 4 || level == 10) {
        this.wish.y = 299;
        if (level == 4) {
          this.shadow.setTexture('shadow4');
        }
        if (level == 10) {
          this.shadow.setTexture('shadow10');
        }
        this.shadow.x = 580.11;
        this.shadow.y = 675;

        this.helloQ1.x = 15;
        this.helloQ1.y = 0;
        this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      } else if (level == 5 || level == 9) {
        this.wish.y = 328;
        if (level == 5) {
          this.shadow.setTexture('shadow5');
        }
        if (level == 9) {
          this.shadow.setTexture('shadow9');
        }
        this.shadow.x = 548.95;
        this.shadow.y = 668;

        this.helloQ1.x = -40;
        this.helloQ1.y = 0;
        this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      } else if (level == 6) {
        this.wish.y = 328;
        this.shadow.setTexture('shadow6');
        this.shadow.x = 548.95;
        this.shadow.y = 668;

        this.helloQ1.x = -40;
        this.helloQ1.y = 0;
        this.questionFloors[next].setTexture(this.floorNo[next] + '_on');
      }

      const beedTargetByLevel = {
        1: 362.5 + 4 * 56,
        2: 362.5 - 5 * 56,
        3: 362.5 - 3 * 56,
        4: 362.5 - 2 * 56,
        5: 362.5 + 5 * 56,
        6: 362.5 - 1 * 56,
        7: 362.5 - 4 * 56,
        8: 362.5 + 3 * 56,
        9: 362.5 + 2 * 56,
        10: 362.5 + 1 * 56,
      };
      const steps = Math.round(Math.abs(clickedY - currentY) / 56);
      const beedDurationByStep = {
        1: 1500,
        2: 3000,
        3: 4000,
        4: 5000,
        5: 6000,
        6: 7000,
        7: 8000,
        8: 9000,
        9: 10000,
        10: 11000,
      };
      const volFadeDelayByStep = {
        1: 1200,
        2: 2200,
        3: 3200,
        4: 4200,
        5: 5200,
        6: 6200,
        7: 7200,
        8: 8200,
        9: 9200,
        10: 10200,
      };
      const beedDuration = beedDurationByStep[steps];
      const volFadeDelay = volFadeDelayByStep[steps];

      this.tweens.add({
        targets: [this.beed],
        y: beedTargetByLevel[level],
        ease: 'sine.easeInOut',
        duration: beedDuration,
        repeat: 0,
        onStart: () => {
          this.tweens.add({
            targets: [this.vol],
            x: 1,
            ease: 'sine.easeIn',
            duration: 400,
            repeat: 0,
          });

          this.tweens.add({
            targets: [this.vol],
            x: 0,
            ease: 'sine.easeOut',
            duration: 400,
            delay: volFadeDelay,
            repeat: 0,
          });
        },

        onComplete: () => {
          this.erfloorAudio.play();
          this.number.setColor('#3DD771');
          bulb++;
          gameState.bulbs = bulb;
          gameState.score++;
          if (levelSkippedNo == 0) next++;
          if (levelSkippedNo > 0) next = next + levelSkippedNo + 1;
          //console.log("LevelGreen"+level);
          this.questionFloors[next].setTexture(this.floorNo[next] + '_c');
          if (clickedY > currentY) this.downArrow.setTexture('downArrow_c');
          if (clickedY < currentY) this.upArrow.setTexture('upArrow_c');

          if (bulb == 1) this.green1.setVisible(true);
          else if (bulb == 2) this.green2.setVisible(true);
          else if (bulb == 3) this.green3.setVisible(true);
          else if (bulb == 4) this.green4.setVisible(true);
          else if (bulb == 5) this.green5.setVisible(true);
          else if (bulb == 6) this.green6.setVisible(true);

          this.tweens.add({
            targets: this.ldoor,
            x: 432 - 365,
            ease: 'Linear',
            delay: 200,
            duration: 2300,
            repeat: 0,
            onStart: () => {
              this.edopenAudio.play();
            },
          });

          this.tweens.add({
            targets: this.rdoor,
            x: 430 + 365,
            ease: 'Linear',
            delay: 200,
            duration: 2300,
            repeat: 0,

            onComplete: () => {
              if (level <= 10) {
                if (level == 1) this.helloQ1.play('helloQ1');
                if (level == 2 || level == 7) this.helloQ1.play('helloQ2');
                if (level == 3 || level == 8) this.helloQ1.play('helloQ3');
                if (level == 4 || level == 10) this.helloQ1.play('helloQ4');
                if (level == 5 || level == 6 || level == 9) this.helloQ1.play('helloQ5');
                //this.helloQ1.play('helloQ'+level)

                this.time.delayedCall(
                  770,
                  () => {
                    // this.helloQ1.play('helloQ'+level+'2')
                    if (level == 1) this.helloQ1.play('helloQ12');
                    if (level == 2 || level == 7) this.helloQ1.play('helloQ22');
                    if (level == 3 || level == 8) this.helloQ1.play('helloQ32');
                    if (level == 4 || level == 10) this.helloQ1.play('helloQ42');
                    if (level == 5 || level == 6 || level == 9)
                      this.helloQ1.play('helloQ52');
                    if (level < 5 && retry == false) {
                      this.anims.create({
                        key: 'helloI' + (level + 1),
                        frames: this.anims.generateFrameNames(
                          'CharacterQ' + (level + 1) + 'Anim',
                          {
                            start: 0,
                            end: 0,
                            prefix: 'CharacterQ' + (level + 1) + '_',
                            suffix: '.png',
                          },
                        ),
                        frameRate: 30,
                        repeat: -1,
                      });

                      this.anims.create({
                        key: 'helloQ' + (level + 1),
                        frames: this.anims.generateFrameNames(
                          'CharacterQ' + (level + 1) + 'Anim',
                          {
                            start: 0,
                            end: 22,
                            prefix: 'CharacterQ' + (level + 1) + '_',
                            suffix: '.png',
                          },
                        ),
                        frameRate: 30,
                        repeat: 0,
                      });

                      this.anims.create({
                        key: 'helloQ' + (level + 1) + '2',
                        frames: this.anims.generateFrameNames(
                          'CharacterQ' + (level + 1) + 'Anim',
                          {
                            start: 23,
                            end: 68,
                            prefix: 'CharacterQ' + (level + 1) + '_',
                            suffix: '.png',
                          },
                        ),
                        frameRate: 30,
                        repeat: 4,
                      });
                    } //if(level<5 close)
                  },
                  [],
                  this,
                );

                this.confetti.play('epop');
                this.confettiWelcome.play();
                this.tweens.add({
                  targets: this.wish,
                  alpha: 1,
                  ease: 'sine.easeOut',
                  delay: 200,
                  duration: 400,
                  repeat: 0,
                });

                this.tweens.add({
                  targets: this.ldoor,
                  x: 432,
                  ease: 'Linear',
                  delay: 5200,
                  duration: 2300,
                  repeat: 0,
                });

                this.tweens.add({
                  targets: this.rdoor,
                  x: 430,
                  ease: 'Linear',
                  delay: 5200,
                  duration: 2300,
                  repeat: 0,
                  onStart: () => {
                    this.edopenAudio.play();
                  },

                  onComplete: () => {
                    this.wish.setAlpha(0);
                    gameState.attempted++;
                    this.number.setColor('#FFCF56');
                    this.upArrow.setTexture('upArrow');
                    this.downArrow.setTexture('downArrow');
                    if (level < 10) level++;
                    wrongAttempt = 0;
                    gameState.wrong = 0;

                    if (
                      (gameState.score >= 6 && gameState.attempted <= 10) ||
                      (gameState.attempted >= 10 && gameState.score < 6)
                    ) {
                      if (gameState.score >= 6) {
                        gameState.win = true;
                        this.statement.setAlpha(0);
                      }
                      if (gameState.score < 6) {
                        gameState.win = false;
                      }
                      this.tweens.add({
                        targets: this.bgAudio,
                        volume: 0,
                        ease: 'Linear',
                        duration: 500,
                        delay: 50,
                        repeat: 0,
                        onComplete: () => {
                          this.bgAudio.stop();
                          this.bgAudio.destroy();
                        },
                      });
                      //this.bgAudio.setVolume(0).setLoop(false);

                      // cam.fadeOut(500, 255, 255, 255);
                      // cam.once('camerafadeoutcomplete', function (camera) {
                      retry = true;
                      //this.scene.stop('StartScene');
                      this.blurFunction();
                      this.scene.launch('EndScene');
                      //  this.scene.stop("GameScene");
                      //  },this);
                    } else {
                      this.tweens.add({
                        targets: this.statement,
                        alpha: 1,
                        ease: 'sine.easeOut',
                        delay: 200,
                        duration: 400,
                        repeat: 0,
                        onComplete: () => {
                          this.press1 = true;
                          for (let i = 0; i <= 10; i++) {
                            this.floors[i].setInteractive();
                          }
                          this.questionFloors[next]
                            .disableInteractive()
                            .setTexture(this.floorNo[next] + '_d');
                          levelSkippedNo = 0;
                          currentY = this.questionFloors[next].y;
                          // gameState.attempted++;
                          gameState.lastButton = this.questionFloors[next].y;
                          gameState.lastButtonName = this.floorNo[next] + '_d';
                          gameState.beedY = 362.5 - this.floorNo[next] * 56;
                          gameState.floorNo = this.floorNo[next];
                          // if ((gameState.score >= 1 && gameState.attempted <= 10) || (gameState.attempted >= 10 && gameState.score < 6)) {
                          //   if (gameState.score >= 1) {
                          //     gameState.win = true;
                          //     this.statement.setAlpha(0);
                          //   }
                          //   if (gameState.score < 6) {
                          //     gameState.win = false;
                          //   }
                          //   this.tweens.add({
                          //     targets: this.bgAudio,
                          //     volume: 0,
                          //     ease: "Linear",
                          //     duration: 500,
                          //     delay: 50,
                          //     repeat: 0,
                          //     onComplete: () => {
                          //       this.bgAudio.stop();
                          //       this.bgAudio.destroy();
                          //     },
                          //   });
                          //   //this.bgAudio.setVolume(0).setLoop(false);

                          //   // cam.fadeOut(500, 255, 255, 255);
                          //   // cam.once('camerafadeoutcomplete', function (camera) {
                          //   retry = true;
                          //   //this.scene.stop('StartScene');
                          //   this.blurFunction();
                          //   this.scene.launch("EndScene");
                          //   //  this.scene.stop("GameScene");
                          //   //  },this);
                          // }
                        },
                      });
                    }
                  },
                });
              }
            },
          });
        },
      });
    } else if (pressed) {
      // console.log("WRONG");
      wrongClicked = true;
      this.ebpressAudio.play();
      this.press1 = false;
      pressed = false;
      this.statement.setAlpha(0);
      wrongAttempt++;
      gameState.wrong = wrongAttempt;
      //hint-1 added
      if (gameState.wrong <= 2) {
        this.time.delayedCall(
          2000,
          () => {
            gameState.hintState = true;
            gameState.prevHint = 0;
          },
          [],
          this,
        );
      }

      //console.log("wrongAttempt"+wrongAttempt);
      if (wrongAttempt > 2) {
        if (level >= 1 && level <= 4 && retry == false) {
          this.anims.create({
            key: 'helloI' + (level + 1),
            frames: this.anims.generateFrameNames('CharacterQ' + (level + 1) + 'Anim', {
              start: 0,
              end: 0,
              prefix: 'CharacterQ' + (level + 1) + '_',
              suffix: '.png',
            }),
            frameRate: 30,
            repeat: -1,
          });

          this.anims.create({
            key: 'helloQ' + (level + 1),
            frames: this.anims.generateFrameNames('CharacterQ' + (level + 1) + 'Anim', {
              start: 0,
              end: 22,
              prefix: 'CharacterQ' + (level + 1) + '_',
              suffix: '.png',
            }),
            frameRate: 30,
            repeat: 0,
          });

          this.anims.create({
            key: 'helloQ' + (level + 1) + '2',
            frames: this.anims.generateFrameNames('CharacterQ' + (level + 1) + 'Anim', {
              start: 23,
              end: 68,
              prefix: 'CharacterQ' + (level + 1) + '_',
              suffix: '.png',
            }),
            frameRate: 30,
            repeat: 4,
          });
        }
        gameState.hintState = false;
        this.press1 = false;
        pressed = false;
        this.statement.setAlpha(0);
        if (level < 10) level++;
        wrongAttempt = 0;
        gameState.wrong = 0;
        gameState.attempted++;
        // gameState.lastButton= this.questionFloors[next].y;
        levelSkippedNo++;
      }

      for (let i = 0; i <= 10; i++) {
        this.floors[i].disableInteractive();
      }
      this.questionFloors[next].setTexture(this.floorNo[next] + '_on');

      this.time.delayedCall(
        500,
        () => {
          this.incorrectAudio.play();

          this.cameras.main;
          this.tweens.add({
            targets: [this.upArrow_w, this.downArrow_w],
            alpha: 1,
            ease: 'Stepped',
            duration: 200,
            repeatDelay: 200,
            repeat: 3,
          });

          this.tweens.add({
            targets: [this.upArrow_w, this.downArrow_w],
            alpha: 0,
            ease: 'Stepped',
            duration: 200,
            delay: 200,
            repeatDelay: 200,
            repeat: 3,
          });

          if (val == 5) {
            this.Floor5.setTexture('5_w');
          } else if (val == 4) {
            this.Floor4.setTexture('4_w');
          } else if (val == 3) {
            this.Floor3.setTexture('3_w');
          } else if (val == 2) {
            this.Floor2.setTexture('2_w');
          } else if (val == 1) {
            this.Floor1.setTexture('1_w');
          } else if (val == 0) {
            this.Floor0.setTexture('0_w');
          } else if (val == -1) {
            this.FloorMinus1.setTexture('-1_w');
          } else if (val == -2) {
            this.FloorMinus2.setTexture('-2_w');
          } else if (val == -3) {
            this.FloorMinus3.setTexture('-3_w');
          } else if (val == -4) {
            this.FloorMinus4.setTexture('-4_w');
          } else if (val == -5) {
            this.FloorMinus5.setTexture('-5_w');
          }
        },
        [],
        this,
      );

      this.time.delayedCall(
        2200,
        () => {
          this.press1 = true;
          wrongClicked = false;
          this.tweens.add({
            targets: this.statement,
            alpha: 1,
            ease: 'sine.easeOut',
            duration: 400,
            repeat: 0,
            onComplete: () => {
              for (let i = 0; i <= 10; i++) {
                this.floors[i].setInteractive().setTexture(5 - i + '_on');
              }
              this.questionFloors[next]
                .disableInteractive()
                .setTexture(this.floorNo[next] + '_d');
              currentY = this.questionFloors[next].y;

              gameState.lastButton = this.questionFloors[next].y;
              gameState.lastButtonName = this.floorNo[next] + '_d';
              gameState.beedY = 362.5 - this.floorNo[next] * 56;
              gameState.bulbs = bulb;
              gameState.floorNo = this.floorNo[next];

              if (gameState.attempted >= 10 && gameState.score < 6) {
                this.tweens.add({
                  targets: this.bgAudio,
                  volume: 0,
                  ease: 'Linear',
                  duration: 500,
                  delay: 50,
                  repeat: 0,
                  onComplete: () => {
                    this.bgAudio.stop();
                    this.bgAudio.destroy();
                  },
                });
                //this.bgAudio.setVolume(0).setLoop(false);
                gameState.win = false;
                this.statement.setAlpha(0);
                //.fadeOut(500, 255, 255, 255);
                // cam.once('camerafadeoutcomplete', function (camera) {
                retry = true;
                //this.scene.pause('StartScene');
                this.blurFunction();
                this.scene.launch('EndScene');
                //  this.scene.stop("GameScene");
                // },this);
              }
            },
          });
        },
        [],
        this,
      );
    } //wrong else if close

    if (this.beed.y <= 362.5 - 4.5 * 56) {
      this.number.setText('5');
    } else if (this.beed.y <= 362.5 - 3.5 * 56) {
      this.number.setText('4');
    } else if (this.beed.y <= 362.5 - 2.5 * 56) {
      this.number.setText('3');
    } else if (this.beed.y <= 362.5 - 1.5 * 56) {
      this.number.setText('2');
    } else if (this.beed.y <= 362.5 - 0.5 * 56) {
      this.number.setText('1');
    } else if (this.beed.y <= 362.5 + 0.5 * 56) {
      this.number.setText('0');
    } else if (this.beed.y <= 362.5 + 1.5 * 56) {
      this.number.setText('-1');
    } else if (this.beed.y <= 362.5 + 2.5 * 56) {
      this.number.setText('-2');
    } else if (this.beed.y <= 362.5 + 3.5 * 56) {
      this.number.setText('-3');
    } else if (this.beed.y <= 362.5 + 4.5 * 56) {
      this.number.setText('-4');
    } else if (this.beed.y <= 362.5 + 5.5 * 56) {
      this.number.setText('-5');
    }

    if (gameState.hintClicked == true) {
      for (let i = 0; i <= 10; i++) this.floors[i].disableInteractive();
    }

    if (
      gameState.hintClicked == false &&
      wrongAttempt > 0 &&
      gameState.hintState == false &&
      wrongClicked == false
    ) {
      for (let i = 0; i <= 10; i++) this.floors[i].setInteractive();

      this.questionFloors[next].disableInteractive();
    }
  }
}
